import { render, staticRenderFns } from "./Amendments.vue?vue&type=template&id=5ae5f21b&"
import script from "./Amendments.vue?vue&type=script&lang=js&"
export * from "./Amendments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports